import styled from 'styled-components';
import { Index } from '../../TrailPage/Waypoints/waypointStyles';

export const StoryPlacesContainer = styled.section`
	h3 {
		margin: 0;
	}
`;

export const StoryPlaceIndex = styled(Index)`
	display: inline-flex;
`;

export const StoryPlaceContainer = styled.div`
	padding: 1rem 1rem 0;
	margin-bottom: 2rem;
	border-top: 1px solid var(--ion-color-medium);
`;

export const StoryPlaceImgContainer = styled.div`
	width: 100%;
	aspect-ratio: 16/9;
	border-radius: 12px;
	box-shadow: var(--generic-box-shadow);
	overflow: hidden;
	margin-bottom: 1rem;
	position: relative;
	/* max-height: 200px; */
	a {
		width: 100%;
		height: 100%;
	}
	img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		object-position: center center;
		display: block;
	}
`;

export const StoryPlaceTextContainer = styled.div`
	padding: 0 1rem;
	h3 {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
	}
`;

export const StoryPlaceMeta = styled.p`
	margin: 2px 0 8px;
	font-size: 12px;
	//text-transform: uppercase;
	color: var(--ion-color-secondary);
`;

export const StoryPlaceDescription = styled.p`
	margin: 0;
	font-size: 14px;
	line-height: 1.4;
	font-weight: 350;
`;
